/**
 * Calendar (Figma 09 · Form pages / 12): the chapter 08 calendar settings
 * panel, placed on the Settings page. The calendar's own sheet uses the same
 * component.
 */
import { useCalendarSettings } from "@/app/routes/dashboard/content-calendar/api/useContentCalendar";
import CalendarSettingsModal from "@/app/routes/dashboard/content-calendar/components/CalendarSettingsModal";
import { ErrorState } from "../../ViewStates";
import { CardLoading, PageHead, SettingsPage } from "../parts/SettingsParts";
import { NeedBrand, useBrandHead } from "../parts/scope";

const noop = () => {};

export default function CalendarSettingsPage() {
  const head = useBrandHead();
  const brandId = head.brand?.id ?? null;
  const { data: settings, isLoading, isError, refetch } = useCalendarSettings(brandId);

  return (
    <SettingsPage>
      <PageHead
        {...head}
        title="Calendar"
        status={
          brandId
            ? `How ${head.brandName}’s calendar plans: posts a month, planning, time zone and posting times.`
            : undefined
        }
      />
      {!brandId ? (
        <NeedBrand />
      ) : isLoading ? (
        <CardLoading caption={`Loading ${head.brandName}’s calendar settings`} />
      ) : isError || !settings ? (
        <ErrorState
          title="The calendar settings did not load"
          body="Creo could not read them. Nothing has changed."
          onRetry={() => void refetch()}
        />
      ) : (
        <CalendarSettingsModal
          key={brandId}
          inline
          brandId={brandId}
          brandName={head.brand?.name ?? null}
          settings={settings}
          onClose={noop}
        />
      )}
    </SettingsPage>
  );
}
